import { WARNINGS_NOT_AVAILABLE_MESSAGE } from 'redux-state/weather-warnings/types.js';

export const WarningsPanelHeaderFailure = () => (
  <li className="WeatherWarning-bar-warning-item u-lg-block u-xl-block">{WARNINGS_NOT_AVAILABLE_MESSAGE}</li>
);
